export default {
	data() {
		return {
			sendingForm: false,
			get rootAPI() {
				return __API__
				// return process.env.__API__
			}
		}
	},
	computed: {
		
	},
	methods: {

	}
}
